import { h, render } from 'preact';

import {EditGridState, EditGridView} from '../types/edit-grid';
import {getEditGridProps} from './props/app/EditGrid';
import {EditGrid} from './components/EditGrid';
import {updateGridSize} from './props/app/product-grid-utils';

export const initEditGrid = (): void => {
    const container = document.querySelector('.edit-grid');

    if (!container) {
        return;
    }

    const state: EditGridState = {
        ...window.initialEditGridState,
    };

    const view: EditGridView = {
        state,
        update: (): void => {
            const props = getEditGridProps(view);
            render(h(EditGrid, props), container);
        },
        timeouts: new Map(),
    };

    updateGridSize(view)
    view.update(); // First render

    window.addEventListener('beforeunload', (event) => {
        if (state.anyChanges) {
            event.preventDefault()
            event.returnValue = true
        }
    })
};
